import React from 'react';
import { Link } from 'react-router-dom';
import { Scale, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img src="/assets/img/brand/logo-light.png" alt="Federal Trademark Experts" className="h-10" />
            </div>
            <p className="text-slate-400 text-sm mb-4">
              Your trusted partner for trademark registration, copyright protection, patent services, and company formation across the United States.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-slate-400 hover:text-blue-400 transition-colors text-sm">Home</Link></li>
              <li><Link to="/about" className="text-slate-400 hover:text-blue-400 transition-colors text-sm">About Us</Link></li>
              <li><Link to="/services/trademark/register" className="text-slate-400 hover:text-blue-400 transition-colors text-sm">Trademark Services</Link></li>
              <li><Link to="/services/company/llc" className="text-slate-400 hover:text-blue-400 transition-colors text-sm">Company Formation</Link></li>
              <li><Link to="/contact" className="text-slate-400 hover:text-blue-400 transition-colors text-sm">Contact Us</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2">
              <li><Link to="/services/trademark/register" className="text-slate-400 hover:text-blue-400 transition-colors text-sm">Trademark Registration</Link></li>
              <li><Link to="/services/copyright/register" className="text-slate-400 hover:text-blue-400 transition-colors text-sm">Copyright Registration</Link></li>
              <li><Link to="/services/patent/application" className="text-slate-400 hover:text-blue-400 transition-colors text-sm">Patent Filing</Link></li>
              <li><Link to="/services/company/llc" className="text-slate-400 hover:text-blue-400 transition-colors text-sm">LLC Formation</Link></li>
              <li><Link to="/services/legal/immigration" className="text-slate-400 hover:text-blue-400 transition-colors text-sm">Legal Services</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3 text-slate-400 text-sm">
                <MapPin className="h-5 w-5 mt-0.5 flex-shrink-0" />
                <span>1149 S Hill St<br />Los Angeles, CA 90015</span>
              </li>
              <li className="flex items-center space-x-3 text-slate-400 text-sm">
                <Phone className="h-5 w-5 flex-shrink-0" />
                <span>+1 (844) 490-3064</span>
              </li>
              <li className="flex items-center space-x-3 text-slate-400 text-sm">
                <Mail className="h-5 w-5 flex-shrink-0" />
                <span>info@federaltrademarkexperts.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-8 text-center">
          <p className="text-slate-400 text-sm">
            © {new Date().getFullYear()} Federal Trademark Experts. All rights reserved. | 
            <Link to="/privacy-policy" className="hover:text-blue-400 transition-colors ml-2">Privacy Policy</Link> | 
            <Link to="/terms-and-conditions" className="hover:text-blue-400 transition-colors ml-2">Terms of Service</Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;